import { getISOWeek } from 'date-fns';
import {
  CalendarDateFormatter,
  DateFormatterParams,
  CalendarEvent
} from "angular-calendar";
import { DatePipe } from "@angular/common";

export class CustomDateFormatterProvider extends CalendarDateFormatter {

  public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "EEE", locale);
  }

  public monthViewTitle({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "MMM y", locale);
  }

    public dayViewTitle({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "EEEE d MMMM y", locale);
  }


  public weekViewColumnHeader({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "EE", locale);
  }

  public weekViewColumnSubHeader({
    date,
    locale
  }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "dd", locale);
	}
	
	public weekViewTitle({ date, locale }: DateFormatterParams): string {
    const year: string = new DatePipe(locale).transform(date, 'y', locale);
    const weekNumber: number = getISOWeek(date);
    return `Semaine ${weekNumber} en ${year}`;
  }

  public dayViewHour({ date, locale }: DateFormatterParams): string {
    return new DatePipe(locale).transform(date, "HH:mm", locale);
  }

  monthTooltip(event: CalendarEvent): string {
    return;
  }

  weekTooltip(event: CalendarEvent): string {
    return;
  }

  dayTooltip(event: CalendarEvent): string {
    return;
  }

}



// WEBPACK FOOTER //
// ./src/providers/custom-date-formatter/custom-date-formatter.ts